import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'repeat',
    standalone: false
})
export class RepeatPipe implements PipeTransform {

  transform(times: number, value: string = '1fr'): string {
    if (!times) {
      return ''
    }
    return `repeat(${times}, ${value})`
  }
}
